// import {
//   isNetworkReachable,
//   isConnected,
// } from "react-native-reachability-popup";
import ApiService from "../services/ApiService";
import notificationService from "../services/notification.service";

// TODO: Handle unhandel prmomise rejection on failure
export async function request({
    url, //Service url
    method, //Web Service type 'post,get,put,delete....'
    params, //Paramter for request
    config, //APIrequest Configuration
    showLoader = true, //Show spinner
    showToast = true
}) {
    //   if (!isNetworkReachable() && !isConnected()) {
    //     return {
    //       type: NO_INTERNET,
    //     };
    //   }
    // showLoader && showSpinner();
    const response = (await ApiService[method]?.(url, params, config)) || {};

    // hideSpinner();
    if (response.ok) {
        return response;
    } else {
        showToast && notificationService.error(response?.response?.message);
        // response.response is what ApiService.handleResponse produced: a { code, message }
        // pair, with the server's Data already discarded. Passing that object straight to
        // Error() yielded message === "[object Object]", so callers could never match on
        // it. Reading .message fixes that, but note error.payload carries NO field-level
        // detail — surfacing per-field server errors would mean changing handleResponse to
        // stop dropping Data, not just changing this line.
        const error = new Error(response?.response?.message || "Request failed");
        error.payload = response?.response;
        error.status = response?.status;
        throw error;
    }
}
